import { IVector3Like } from '@babylonjs/core/Maths/math.like';
import remove from 'lodash/remove';
import find from 'lodash/find';

import { EngineBuilder } from './engineBuilder';
import { IComment, UiComments } from '../Ui/uiComments';

export class EngineComment extends EngineBuilder {

    public uiComments: UiComments;

    public get comments(): IComment[] {
        return this._comments
    }
    private _comments: IComment[] = [];

    public addComments(comments: IComment[]) {
        comments.forEach((comment) => {
            this.addComment(comment)
        });
    }

    public addComment(comment: IComment) {
        if (!this.uiComments) {
            this.uiComments = new UiComments(this.system, this.sceneContainer, [])
        }
        this.uiComments.addComment(comment)
        this._comments.push(comment);
    }

    public removeComment(id: string): void {
        remove(this._comments, (c) => c.id === id);
        this.uiComments.removeComment(id)
    }


    public removeAllComment(): void {
        this._comments.forEach((c) => {
            this.uiComments.removeComment(c.id)
        })
        this._comments = []
    }

    public editComment(comment: IComment): void {
        let commentToEdit = find(this._comments, (c) => c.id === comment.id);
        commentToEdit.point = comment.point;
        commentToEdit.date = comment.date;
        commentToEdit.author = comment.author;
        commentToEdit.text = comment.text;
        this.uiComments.editComment(comment)
    }

    public onModelPicked(callback: (point: IVector3Like) => void): void {
        this.contentsManager.listenEvent(true)
        this.system.canvas.addEventListener('dblclick', (e) => {
            const pick = this.system.pick(e);
            const { hit, pickedPoint } = pick
            if (hit) {
                const point = { x: pickedPoint.x, y: pickedPoint.y, z: pickedPoint.z }
                callback(point)
            }
        });
    }

    public showComment(id: string) {
        this.uiComments.showComment(id)
    }

    public hideComment(id: string) {
        this.uiComments.hideComment(id)
    }
}
